/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirmupgradecheckout2Inputs */

const en_confirmupgradecheckout2 = /** @type {(inputs: Confirmupgradecheckout2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You will be taken to the secure payment page to complete this. Nothing is charged before that.`)
};

const de_confirmupgradecheckout2 = /** @type {(inputs: Confirmupgradecheckout2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Abschluss wirst du zur sicheren Bezahlseite weitergeleitet. Erst dort wird die Zahlung fällig.`)
};

/**
* | output |
* | --- |
* | "You will be taken to the secure payment page to complete this. Nothing is charged before that." |
*
* @param {Confirmupgradecheckout2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const confirmupgradecheckout2 = /** @type {((inputs?: Confirmupgradecheckout2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirmupgradecheckout2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirmupgradecheckout2(inputs)
	return de_confirmupgradecheckout2(inputs)
});
export { confirmupgradecheckout2 as "confirmUpgradeCheckout" }